export default __webpack_public_path__ + "static/media/10.c87966b5.jpeg";